import { attr, belongsTo, hasMany } from '@ember-data/model';
import ShModel from 'sh-www/models/sh-model';

class CompanyMembership extends ShModel {
  @attr('boolean') admin;
  @attr('boolean') editor;
  @attr('date') deactivatedAt;

  @belongsTo('company', { async: false }) company;
  @hasMany('companyTeamMembership', { async: false }) companyTeamMemberships;
  @belongsTo('user', { async: false }) user;

  get isDeactivated() {
    return this.deactivatedAt;
  }
}

export default CompanyMembership;
